import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, ToggleButton } from "react-bootstrap";
import { X } from "react-feather";

const BooleanFilter = ({
  column: { filterValue, setFilter, filterOptions: columnFilterOptions },
}) => {
  const [filterOptions, setFilterOptions] = useState([]);

  useEffect(() => {
    setFilterOptions(columnFilterOptions);
  }, [columnFilterOptions]);

  return (
    <React.Fragment>
      <ButtonGroup
        onChange={(e) => {
          console.log("bg", { e: e });
        }}
      >
        {filterOptions.map((opt, idx) => (
          <ToggleButton
            key={idx}
            id={`bool-filter-${idx}`}
            type="radio"
            variant="outline-light"
            name="bool-filter"
            value={opt.value}
            title={opt.title}
            checked={filterValue === opt.value}
            onChange={(e) => {
              setFilter(e.currentTarget.value);
            }}
          >
            {opt.label}
          </ToggleButton>
        ))}
      </ButtonGroup>
      <Button
        variant=""
        className="p-0 m-0"
        onClick={() => {
          setFilter("");
        }}
      >
        <X />
      </Button>
    </React.Fragment>
  );
};

export default BooleanFilter;
